
import { defineComponent } from "vue";
import ExampleText from "@/components/Example/ExampleText.vue";

export default defineComponent({
  name: "column-rule-color",
  components: {
    ExampleText,
  },
});
